import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { InternalOrderDetailModel } from 'src/app/models/shopping/internal-order-detail.model';
import { InternalOrderModel } from 'src/app/models/shopping/internal-order.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { InternalOrderDetailService } from 'src/app/services/shopping/internal-order-detail.service';
@Component({
  selector: 'app-register-internal-order-detail',
  templateUrl: './register-internal-order-detail.component.html',
  styleUrls: ['./register-internal-order-detail.component.scss'],
  standalone: false
})
export class RegisterInternalOrderDetailComponent implements OnInit {

  @Input() internalOrderDetailContract: InternalOrderDetailModel = new InternalOrderDetailModel();
  @Input() internalOrderContract: InternalOrderModel = new InternalOrderModel();
  @Input() newArticlesDetail: number[] = [];
  @Input() disabled: boolean = false;
  @Output() updateListDetail = new EventEmitter<boolean>();
  @Output() isFormView = new EventEmitter<boolean>();

  articleId: number = 0;
  codeNameArticle: string = '';
  swAffectsInventory: boolean = false;
  formInternalOrderDetail: FormGroup = new FormGroup({});
  internalOrderDetailId: number = 0;

  constructor(
    private articleService: ArticleService,
    private formBuilder: FormBuilder,
    private internalOrderDetailService: InternalOrderDetailService,

    private toastr: ToastrService,) { }

  ngOnInit() {
    this.validateForm(new InternalOrderDetailModel());
  }

  async ngOnChanges(changes: SimpleChanges) {
    let internalOrderDetailContract = changes["internalOrderDetailContract"];
    if (internalOrderDetailContract && !internalOrderDetailContract.firstChange) {
      this.validateForm(this.internalOrderDetailContract)
      if (this.internalOrderDetailContract.internalOrderDetailId !== 0) {
        this.internalOrderDetailId = this.internalOrderDetailContract.internalOrderDetailId;
        this.validateForm(this.internalOrderDetailContract);
      }
    }

    let newArticlesDetail = changes["newArticlesDetail"];
    if (newArticlesDetail && newArticlesDetail.currentValue.length > 0) {
      this.createNewInternalOrderDetail(newArticlesDetail.currentValue)
    }
    if (this.disabled) setTimeout(() => this.formInternalOrderDetail.disable(), 0);
  }

  clearForm() {
    this.codeNameArticle = "";
    let modelInternalOrderDetail = new InternalOrderDetailModel;
    this.validateForm(modelInternalOrderDetail)
    this.isFormView.emit(false);
  }

  changeQuantity() {
    const quantity = this.formInternalOrderDetail.get("quantity")?.value;
    const totalDelivered = this.formInternalOrderDetail.get("totalAmountDeliveredQuantity")?.value;
    const totalPurchase = this.formInternalOrderDetail.get("totalPurchaseOrderQuantity")?.value;
    const pendingQuantity = this.swAffectsInventory ? quantity - totalDelivered
      : (totalPurchase > quantity ? 0 : quantity - totalPurchase);
    this.formInternalOrderDetail.controls["pendingQuantity"].setValue(pendingQuantity);
  }

  async createNewInternalOrderDetail(newArticlesDetail: number[]) {
    try {
      await firstValueFrom(this.internalOrderDetailService.createInternalOrderDetail(newArticlesDetail, this.internalOrderContract.internalOrderId));
      this.toastr.success('El detalle del pedido interno fue creado exitosamente.', '', {
        timeOut: 5000, progressBar: true, closeButton: true
      });
      this.updateListDetail.emit(true);
    } catch (error) {
      console.error('Error al crear el detalle del pedido interno.', error);
    }
  }

  async getArticle(articleId: number | null) {
    try {
      if (articleId != null && articleId != 0) {
        let article = await firstValueFrom(this.articleService.getArticleById(articleId));
        if (article) {
          this.articleId = articleId;
          this.codeNameArticle = article.code + " - " + article.name;
          this.swAffectsInventory = article.swAffectsInventory;
        } else {
          this.articleId = 0;
          this.codeNameArticle = "Error al buscar el elemento. Por favor refresque la página.";
          this.swAffectsInventory = false;
        }
      } else {
        this.articleId = 0;
        this.codeNameArticle = "";
        this.swAffectsInventory = false;
      }
    } catch (error) {
      console.error('Error al obtener el artículo:', error);
      this.articleId = 0;
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView.emit(isFormView);
  }

  async send() {
    if (this.formInternalOrderDetail.valid) {
      let modelInternalOrderDetail = this.formInternalOrderDetail.value as InternalOrderDetailModel;
      this.internalOrderDetailContract.quantity = modelInternalOrderDetail.quantity;
      this.internalOrderDetailContract.swUrgent = modelInternalOrderDetail.swUrgent;
      try {
        await firstValueFrom(this.internalOrderDetailService.updateInternalOrderDetail(this.internalOrderDetailContract));
        this.toastr.success('El detalle del pedido interno fue modificado exitosamente.', '', {
          timeOut: 5000, progressBar: true, closeButton: true
        });
        this.internalOrderDetailContract = new InternalOrderDetailModel();
        this.clearForm();
        this.isFormView.emit(false);
        this.updateListDetail.emit(true);
      } catch (error) {
        console.error('Error al actualizar el detalle del pedido interno.', error);
      }
    } else {

    }
  }

  async validateForm(internalOrderDetail: InternalOrderDetailModel) {
    setTimeout(() => {
      this.formInternalOrderDetail.controls["totalAmountDeliveredQuantity"].enable();
      this.formInternalOrderDetail.controls["totalPurchaseOrderQuantity"].enable();
      this.formInternalOrderDetail.controls["pendingQuantity"].enable()
    }, 100);

    this.formInternalOrderDetail = this.formBuilder.group({
      internalOrderId: [this.internalOrderContract.internalOrderId, [Validators.required, Validators.min(1)]],
      articleId: [internalOrderDetail.articleId, [Validators.required, Validators.min(1)]],
      quantity: [internalOrderDetail.quantity, [Validators.required, Validators.min(1), Validators.max(9999999.99)]],
      totalAmountDeliveredQuantity: [internalOrderDetail.totalAmountDeliveredQuantity, []],
      totalPurchaseOrderQuantity: [internalOrderDetail.totalPurchaseOrderQuantity, []],
      pendingQuantity: [internalOrderDetail.pendingQuantity, []],
      swUrgent: [internalOrderDetail.swUrgent, []]
    });
    await this.getArticle(internalOrderDetail.articleId);
    setTimeout(() => {
      this.formInternalOrderDetail.controls["totalAmountDeliveredQuantity"].disable();
      this.formInternalOrderDetail.controls["totalPurchaseOrderQuantity"].disable();
      this.formInternalOrderDetail.controls["pendingQuantity"].disable()
    }, 100);
  }
}
